// External libraries
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

// Internal modules
import { CI } from '../customerInteractions';
import { logger } from '../logger';
import { getWeasleyEligibility } from '../weasleyEligibility';
import type { NavigateToReceiptPageCallback } from '@/lib/reactHooks/types';

export const useNavigateToReceiptPage = (): NavigateToReceiptPageCallback => {
  const navigate = useNavigate();

  const navigateToReceiptPage = useCallback(async () => {
    try {
      const eligibilityResponse = await getWeasleyEligibility();

      if (eligibilityResponse?.eligible) {
        logger.info('navigate_to_receipt_triggered');
        navigate({
          pathname: '/checkoutweb/receipt',
          search: window.location.search,
        });
      } else {
        throw new Error('user_not_weasley_eligible');
      }
    } catch (error) {
      CI.fci(CI.ErrorReason.Application);
      if (error instanceof Error) {
        const { message, stack } = error;
        logger.error('redirect_to_receipt_error_on_navigate', {
          message,
          stack,
        });
      } else {
        logger.error('redirect_to_receipt_error_on_navigate');
      }
      throw new Error('redirect_to_receipt_error_on_navigate');
    }
  }, []);

  return navigateToReceiptPage;
};
